import NavigationMenuList from 'atoms/NavigationMenuList';
import Tab from 'atoms/Tab';
import PropTypes from 'prop-types';
import { useNavigationMenu } from 'context/NavigationMenuContext';

const NavigationSidebar = ({ className = '' }) => {
  const { menuItems, footerItems } = useNavigationMenu();

  return (
    <div
      className={`flex flex-col w-l-[18%] flex-none h-[calc(100vh-50px)] py-6 2xl:h-[calc(100vh-70px)] bg-white border-r border-secondary-200 sticky top-0 ${className}`}
    >
      <div className="px-2.5 flex justify-between flex-col flex-grow">
        <NavigationMenuList menuItems={menuItems} />
        <div className="absolute bottom-5 w-[calc(100%-34px)]">
          {footerItems.map((item) => (
            <Tab
              key={item.name}
              iconKey={item.iconKey}
              listName={item.name}
              href={item.href}
              active={item.active}
              disabled={item.disabled}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

NavigationSidebar.propTypes = {
  className: PropTypes.string,
};

export default NavigationSidebar;
